import React from 'react';
import { Button, Icon, Grid, makeStyles, Paper, Typography, Theme } from '@material-ui/core';
import { HomeContext } from '../../Features/Home/HomeContext';
import { PageLocation } from '../enum/PageLocation';
import clsx from 'clsx';

interface ITableEmptyProps {
    displayText: string,
    buttonText?: string,
    pageLocation?: PageLocation,
    cssProperties?: ICssProperties,
}

interface ICssProperties {
    minHeight?: string,
    errorBorder?: boolean
}

const useStyles = makeStyles((theme: Theme) => ({
    noPendingPaper: (props: ICssProperties) => ({
        backgroundColor: theme.palette.background.default,
        borderRadius: '16px',
        minHeight: props.minHeight || '264px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: theme.spacing(1),
        border: props.errorBorder ? `1px solid ${theme.palette.error.main}` : ''
    }),
    containerGrid: {
        maxWidth: '1800px',
        margin: '0px',
        width: '100%'
    },
    noButtonContainerGrid: {
        marginTop: theme.spacing(1)
    },
    paperGrid: {
        margin: '0px',
        width: '100%'
    },
    itemGrid: {
        padding: '0px !important',
        width: '100%',
    },
    button: {
        paddingLeft: 0,
        '&:hover': {
            textDecorationLine: 'underline',
        },
    }
}));

export function TableEmpty({ displayText, buttonText, pageLocation, cssProperties }: ITableEmptyProps) {
    const classes = useStyles(cssProperties || {});

    const homeContext = React.useContext(HomeContext);

    const getButton = () => {
        return (
            <Grid
                item
                xs={12}
            >
                <Button
                    onClick={() => {pageLocation && homeContext.setPageLocation(pageLocation); }}
                    size='large'
                    startIcon={<Icon color='primary'>add</Icon>}
                    className={classes.button}
                >
                    {buttonText}
                </Button>
            </Grid>
        );
    };

    return (
        <Grid
            container
            spacing={2}
            direction='column'
            className={clsx(classes.containerGrid, {
                [classes.noButtonContainerGrid]: !buttonText,
            })}
        >
            { buttonText && getButton() }
            <Grid
                container
                spacing={2}
                alignItems='center'
                direction='column'
                className={classes.paperGrid}
            >
                <Grid
                    item
                    xs={12}
                    className={classes.itemGrid}
                >
                    <Paper
                        elevation={0}
                        className={classes.noPendingPaper}
                    >
                        <Typography
                            variant="h5"
                            color="textSecondary"
                        >
                            {displayText}
                        </Typography>
                    </Paper>
                </Grid>
            </Grid>
        </Grid>
    );
}